<template>
  <div class="p-1">
    <b-container class="esg-single-score-card">
      <b-row>
        <!-- color bar -->
        <b-col cols="1">
          <div class="color-bar"
               :style="{ 'background-color': palette(color) }">
          </div>
        </b-col>
        <!-- /color bar -->

        <b-col class="pl-0">
          <div class="title text-left text-nowrap">{{ title }}</div>
          <b-row>
            <b-col class="pr-0">
              <div>
                <span v-if="loading"
                      class="spinner-border spinner-border-sm mr-2"></span>
                <span v-else
                      class="score mr-2 text-nowrap">{{ formatNumber(score, 0) }}</span>
                <span class="score-unit mr-2 text-nowrap">{{ scoreUnit }}</span>
              </div>
            </b-col>
            <b-col class="d-flex align-items-center"
                   v-if="diff">
            <span class="diff py-0 text-nowrap"
                  :class="diffClass">
              <span v-if="arrow">{{ diff >= 0 ? '▲' : '▼' }}</span>
              {{ `${Math.abs(diff)}${diffUnit}` }}
            </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <slot name="annotation"></slot>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
    },
    score: {},
    scoreUnit: {
      type: String,
    },
    diff: {
      type: Number,
    },
    diffUnit: {
      type: String,
      default: '%'
    },
    color: {
      type: String,
      default: 'green'
    },
    arrow: {
      type: Boolean,
      default: true
    }
  },
  watch: {},
  computed: {
    diffClass() {
      return {
        'diff-up': this.diff >= 0,
        'diff-down': this.diff < 0
      }
    }
  },
  data() {
    return {
      test: 1
    }
  },
  methods: {
    palette(color) {
      switch (color) {
        case 'blue':
          return '#1F71E3';
        case 'yellow':
          return '#FBD308';
        case 'red':
          return '#FF4560';
        case 'green':
          return '#349A6B';
      }
      return color;
    },
    getScoreCardClass(title, labelColor) {
      let targetClass = '';
      switch (title) {
        case '평가완료':
          targetClass = 'score-card-deco-blue';
          break;
        case '미제출':
          targetClass = 'score-card-deco-red';
          break;
        case '반려':
          targetClass = 'score-card-deco-red';
          break;
        case '평가대상':
          targetClass = 'score-card-deco-yellow';
          break;
        case '제출완료':
          targetClass = 'score-card-deco-yellow';
          break;
        case 'Leader':
          targetClass = 'score-card-deco-blue';
          break;
        case 'Average':
          targetClass = 'score-card-deco-yellow';
          break;
        case 'Laggard':
          targetClass = 'score-card-deco-red';
          break;
        default:
          targetClass = 'score-card-deco-blue';
          break;
      }
      switch (labelColor) {
        case 'blue':
          targetClass = 'score-card-deco-blue';
          break;
        case 'red':
          targetClass = 'score-card-deco-red';
          break;
        case 'yellow':
          targetClass = 'score-card-deco-yellow';
          break;
        default:
          break;
      }
      return targetClass
    }
  }
}
</script>

<style scoped>
.esg-single-score-card {
  border: 1px solid lightgray;
  border-radius: 1rem;
  padding: 1rem 1rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.esg-single-score-card .title {
  font-size: 1rem;
  color: #777;
  word-break: keep-all;
}

.esg-single-score-card .score {
  font-size: 1.5rem;
  font-weight: bolder;
}

.esg-single-score-card .score-unit {
  font-size: .8rem;
}

.esg-single-score-card .diff {
  font-size: 1rem;
  font-weight: 600;
}

.esg-single-score-card .diff.diff-up {
  color: #FF4560;
}

.esg-single-score-card .diff.diff-down {
  color: #1f71e3;
}

.esg-single-score-card .color-bar {
  width: 5px;
  height: 100%;
  border-radius: 5px;
}
</style>